import { AppStateResponse, User } from '../types';

async function fetchJson<T>(url: string, options?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  const data = await res.json();
  if (!res.ok) {
    throw new Error((data as any).error || 'An error occurred');
  }
  return data as T;
}

export const api = {
  getMe: () => fetchJson<{ user: User | null; loggedIn: boolean }>('/api/auth/me'),
  loginDemo: () => fetchJson<{ user: User; loggedIn: boolean }>('/api/auth/demo', { method: 'POST' }),
  loginGoogle: (credential: string) =>
    fetchJson<{ user: User; loggedIn: boolean }>('/api/auth/google', {
      method: 'POST',
      body: JSON.stringify({ credential }),
    }),
  logout: () => fetchJson<{ success: boolean }>('/api/auth/logout', { method: 'POST' }),

  getAppState: (kidId?: string) => {
    const url = kidId ? `/api/app-state?kid_id=${encodeURIComponent(kidId)}` : '/api/app-state';
    return fetchJson<AppStateResponse>(url);
  },

  toggleQuest: (questId: string) =>
    fetchJson<{
      success: boolean;
      quest_id: string;
      completed: boolean;
      kid_id: string;
      streak: number;
      personal_stars: number;
      shared_stars: number;
    }>(`/api/quests/${questId}/toggle`, { method: 'POST' }),

  createQuest: (quest: {
    kid_id: string;
    name: string;
    icon_emoji: string;
    repeat_days: string[];
    time_str?: string;
    points: number;
  }) => fetchJson<{ success: boolean; quest_id: string }>('/api/quests', {
    method: 'POST',
    body: JSON.stringify(quest),
  }),

  deleteQuest: (questId: string) =>
    fetchJson<{ success: boolean }>(`/api/quests/${questId}`, { method: 'DELETE' }),

  createKid: (kid: { name: string; avatar_emoji: string; color?: string }) =>
    fetchJson<{ success: boolean; kid_id: string }>('/api/kids', {
      method: 'POST',
      body: JSON.stringify(kid),
    }),

  deleteKid: (kidId: string) =>
    fetchJson<{ success: boolean }>(`/api/kids/${kidId}`, { method: 'DELETE' }),

  createReward: (reward: {
    name: string;
    description?: string;
    emoji: string;
    star_cost: number;
    is_shared: boolean;
    kid_id?: string | null;
  }) =>
    fetchJson<{ success: boolean; reward_id: string }>('/api/rewards', {
      method: 'POST',
      body: JSON.stringify(reward),
    }),

  deleteReward: (rewardId: string) =>
    fetchJson<{ success: boolean }>(`/api/rewards/${rewardId}`, { method: 'DELETE' }),

  redeemReward: (rewardId: string, pin: string, kidId: string) =>
    fetchJson<{
      success: boolean;
      message: string;
      reward_name: string;
      reward_emoji: string;
      star_cost: number;
    }>(`/api/rewards/${rewardId}/redeem`, {
      method: 'POST',
      body: JSON.stringify({ pin, kid_id: kidId }),
    }),

  verifyPin: (pin: string) =>
    fetchJson<{ valid: boolean; isInitialSetup?: boolean }>('/api/adult/pin/verify', {
      method: 'POST',
      body: JSON.stringify({ pin }),
    }),

  setPin: (pin: string, oldPin?: string) =>
    fetchJson<{ success: boolean; message: string }>('/api/adult/pin/set', {
      method: 'POST',
      body: JSON.stringify({ pin, oldPin }),
    }),
};
